import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { NavigationProvider } from "@/contexts/NavigationContext";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import { RoleProvider } from "@/contexts/RoleContext";
import { StripeProvider } from "@/components/subscription/StripeProvider";
import { SupabaseAuthProvider } from "@/components/auth/SupabaseAuthProvider";

const queryClient = new QueryClient();

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SupabaseAuthProvider>
        <RoleProvider>
          <SubscriptionProvider>
            <NavigationProvider>
              <ThemeProvider>
                <StripeProvider>
                  {children}
                  <Toaster />
                </StripeProvider>
              </ThemeProvider>
            </NavigationProvider>
          </SubscriptionProvider>
        </RoleProvider>
      </SupabaseAuthProvider>
    </QueryClientProvider>
  );
}